module.exports = __webpack_public_path__ + "static/222-4ff8a895a46deedf647de7abc4dd80dd.png";